module.exports = __webpack_public_path__ + "img/product-shot_07_loading.5e69e0d5.jpg";